import {observer} from "mobx-react-lite";
import {animation} from "../stores/AnimationStore";
import React from "react";
import {COLORS} from "../model";
import './ColorsSelectors.css';

export const ColorsSelector = observer(() => {

    return (
        <div className="colors-selector f mt10">
            colors:&nbsp;<input type="search" className="colors-selection" value={animation.colorsList} onChange={e => animation.updateColorsList(e.target.value)} />
            <div className="selected-colors-names">
                {animation.colors.map((c, i) => <span key={`${c}.${i}`}>{c === 0 ? '-' : COLORS[c]}</span>)}
            </div>
        </div>

    );

});
